import { AutoLinkNode, LinkNode } from "@lexical/link";
import { $applyNodeReplacement, EditorConfig } from "lexical";

export class CustomLinkNode extends LinkNode {
  static getType(): string {
    return "custom-link";
  }

  static clone(node: CustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(
      node.__url,
      {
        rel: node.__rel ?? undefined,
        target: node.__target ?? undefined,
        title: node.__title ?? undefined
      },
      node.__key
    );
  }

  createDOM(config: EditorConfig) {
    const element = super.createDOM(config);
    if (element instanceof HTMLAnchorElement) {
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener noreferrer");
    }
    return element;
  }

  updateDOM(
    prevNode: this,
    element: HTMLElement,
    config: EditorConfig
  ): boolean {
    const updated = super.updateDOM(prevNode, element, config);
    if (element instanceof HTMLAnchorElement) {
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener noreferrer");
    }
    return updated;
  }
}

export function $createCustomLinkNode(
  url: string,
  attributes?: { rel?: string; target?: string; title?: string }
): CustomLinkNode {
  return $applyNodeReplacement(new CustomLinkNode(url, attributes));
}

export class CustomAutoLinkNode extends AutoLinkNode {
  static getType(): string {
    return "custom-autolink";
  }

  static clone(node: CustomAutoLinkNode): CustomAutoLinkNode {
    return new CustomAutoLinkNode(
      node.__url,
      {
        rel: node.__rel ?? undefined,
        target: node.__target ?? undefined,
        title: node.__title ?? undefined
      },
      node.__key
    );
  }

  createDOM(config: EditorConfig) {
    const element = super.createDOM(config);
    if (element instanceof HTMLAnchorElement) {
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener noreferrer");
    }
    return element;
  }

  updateDOM(
    prevNode: this,
    element: HTMLElement,
    config: EditorConfig
  ): boolean {
    const updated = super.updateDOM(prevNode, element, config);
    if (element instanceof HTMLAnchorElement) {
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener noreferrer");
    }
    return updated;
  }
}

export function $createCustomAutoLinkNode(
  url: string,
  attributes?: { rel?: string; target?: string; title?: string }
): CustomAutoLinkNode {
  return $applyNodeReplacement(new CustomAutoLinkNode(url, attributes));
}
